import { render, staticRenderFns } from "./Disassembly.vue?vue&type=template&id=fa50c2ee&scoped=true"
import script from "./Disassembly.vue?vue&type=script&lang=js"
export * from "./Disassembly.vue?vue&type=script&lang=js"
import style0 from "./Disassembly.vue?vue&type=style&index=0&id=fa50c2ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa50c2ee",
  null
  
)

export default component.exports